import styled from '@emotion/styled';
import styleService from '@nykaa/deals-utils/styles';
const { getFontStyles, getMarginStyles, getPaddingStyles, setVisibility, } = styleService.utils;
export const SectionHeaderWrapper = styled.div `
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: end;
  margin-bottom: ${({ isDefaultWidgetTopSpacingNeeded }) => `${isDefaultWidgetTopSpacingNeeded}em`};
`;
export const TitleDescriptionWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const ButtonWraopper = styled.div `
  display: flex;
  flexDirection: column;
  align-self: flex-end;
  align-content: flex-end;
  align-items: flex-end;
  `;
export const Description = styled.p `
  ${({ text }) => getFontStyles(text)};
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  display: -webkit-box;
  -webkit-line-clamp: ${({ text }) => text.maxLines.web};
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-right: -1em;
  padding-right: 1em;
  ${({ visible, isVisibilty }) => isVisibilty && setVisibility(visible)};
`;
export const Title = styled.h2 `
  ${({ text }) => getFontStyles(text)};
  ${({ padding }) => getPaddingStyles(padding)};
  text-transform: capitalize;
  display: -webkit-box;
  -webkit-line-clamp: ${({ text }) => text.maxLines.web};
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin:0;
  margin-right: -1em;
  padding-right: 1em;
  ${({ visible, isVisibilty }) => isVisibilty && setVisibility(visible)};
`;
